import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, Observable, Subject, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from 'src/app/services/shared.service';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { AppState } from 'src/app/store/app.state';
import { getUserProfile } from 'src/app/store/selectors/account.selector';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss']
})
export class AdminHeaderComponent implements OnInit {

  getUserProfile$: Observable<any>;
  userProfile: any;

  @Input() pageTitle: string = '';

  @ViewChild('sidenav') sidenav!: MatSidenav;

  showSideNav$: Observable<any>;
  showSidenav: Boolean;

  ngUnsubsribe = new Subject();

  sidenavState: any = 'open';
  sidenavInitState: any = 'open';

  segment: any;

  constructor(
    private store: Store<AppState>,
    private sharedService: SharedService,
    private authService: AuthService,
    private router: Router
  ) {
    this.getUserProfile$ = this.store.select(getUserProfile)
  }

  ngOnInit() { 
    const path = window.location.pathname; 
    this.segment = path.split('/')[1]; 
    this.getUserProfile$.pipe(takeUntil(this.ngUnsubsribe)).subscribe((res) => {
      if(res){
        this.userProfile = res;
      }
    });

    // this.pageTitleService.pageTitle$.subscribe(title => {
    //   this.pageTitle = title;
    // });
  }

  toggleSidenav() {
    this.sharedService.toggle();
  }
  
  
  logout(){
    this.store.dispatch(setLoadingSpinner({status: true}))
    this.authService.autoLogout(this.segment);
  }

  changePassword(){
    this.router.navigateByUrl('/home/change-password');
  }

  get orgHeaderContent(){
    return this.userProfile?.agn_org?.contents?.find((e) => e?.type == 'header1')
  }

  get scpHeaderContent(){
    return this.userProfile?.scp_org?.contents?.find((e) => e?.type == 'header1')
  }
}
